// seller/broker/buyer are legacy values for rows not yet run through scripts/migrateRolesToUser.js
export const USER_ROLES = ['seller', 'broker', 'lawyer', 'admin', 'buyer', 'user'] as const;

export type UserRole = (typeof USER_ROLES)[number];

export const REGISTERABLE_ROLES = ['user'] as const;

export type RegisterableRole = (typeof REGISTERABLE_ROLES)[number];

// accepted wherever 'user' is required, until every pre-merge row and session is gone
export const LEGACY_USER_ROLES: readonly UserRole[] = ['user', 'seller', 'broker', 'buyer'];
